import React, { useEffect, useRef, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { Card, CardActionArea, CardContent, CardMedia, Grid, MenuItem, Paper, Select, TextField } from '@material-ui/core';
import placeHolderProdImage from '../../../prod.png';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    fontFamily: "'SairaCF', 'Saira', Arial",
    fontWeight: 700,
    color: 'rgba(34, 34, 34, 1)',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  title: {
    margin: 0,
    padding: theme.spacing(1),
    fontFamily: "'SairaCF', 'Saira', Arial",
    fontWeight: 600,
    fontSize: '18px',
    color: 'rgba(34, 34, 34, 1)',
    textTransform: 'uppercase'
  }

});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography {...other}>
      <Typography className={classes.title} variant="h6" >{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    marginBottom: '20px'
  },
  dividers: {
    border: 0
  }
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);


const useStyles = makeStyles(theme => ({
  select: {
    bottom: '10px',
    // [theme.breakpoints.down('sm')]: {
    //   bottom: '-1px',
    // },
  },
  root: {
    marginTop: '10px',
    "& .MuiInput-underline:before": {
      border: 0,
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      border: 0,
    },
    "& .MuiInputBase-root":{ 
      marginTop: 0,

    },
    "& .MuiInputBase-input": { // Input Style
      color: 'rgba(34, 34, 34, 1)',
      fontSize: '16px',
      fontFamily: "'SairaCF', Saira', Arial",
      fontWeight: 400,
      backgroundColor: 'rgba(247, 247, 247, 1)',
      border: '0',
      padding: '16px 8px 16px 8px'
    },
    "& .MuiSelect-select": {
      padding: '12px 8px 12px 8px',
      textAlign: 'center'
    },
    "& .MuiFormLabel-root": { // Input Label Style
      color: 'rgba(34, 34, 34, 1)',
      fontSize: '14px',
      fontFamily: "'SairaCF', 'Saira', Arial",
      fontWeight: 600,
      textTransform: 'uppercase',
      position: 'relative',
      lineHeight: '20px'
    },
    "& .MuiFormHelperText-root": {
      color: 'rgba(34, 34, 34, 1)',
      fontSize: '12px',
      fontFamily: "'SairaCF', 'Saira', Arial",
      fontWeight: 400,
      textTransform: 'uppercase',
    },
    "& .Mui-disabled": {
      color: 'rgba(34, 34, 34, 0.25)',
    },
  }
}));

export default function ProductConfigDialog(props) {
  const { product, handleClose, open, setProductsConfigsCallback } = props;
  const classes = useStyles();
  const [buttonEnabled, setButtonEnabled] = useState(false);
  const [productId, setProductId] = useState(null);
  const [productsConfigs, setProductsConfigs] = useState({
    yourWeight: null,
    model: null,
    frontAndBack: null,
    diameter: null,
    experience: '',
    tracksYouLike: null,
    stickerColor: '',
  });
  const bikeWeight = useRef(null);
  const length = useRef(null);

  /*
  // temporarily disabled this part because it leads to clearing of productsConfigs on every typing event on android devices
  useEffect(() => {
    
    if (product.id !== productId) {
      console.log("ProductConfigDialog-variations", product.variations, product.id, productId);
      setProductsConfigs({
        yourWeight: null,
        model: null,
        frontAndBack: null,
        diameter: null,
        experience: '',
        tracksYouLike: null,
        stickerColor: '',
      });
    } else {
      const newProductConfigs = {
        yourWeight: productsConfigs.yourWeight,
        model: productsConfigs.model,
        frontAndBack: productsConfigs.frontAndBack,
        diameter: productsConfigs.diameter,
        experience: productsConfigs.experience,
        tracksYouLike: productsConfigs.tracksYouLike,
        stickerColor: productsConfigs.stickerColor,
      };
      const check = Object.entries(newProductConfigs).some(entry => !entry[1]);
      // setProductsConfigs(newProductConfigs);
      setButtonEnabled(!check);
    }

  }, [props]);
*/

  useEffect(() => {
    const check = Object.entries(productsConfigs).some(entry => !entry[1]);
    console.log(check);
    setButtonEnabled(!check);
    setTimeout(() => {
      const newProductConfigs = {
        yourWeight: productsConfigs.yourWeight,
        model: productsConfigs.model,
        frontAndBack: productsConfigs.frontAndBack,
        diameter: productsConfigs.diameter,
        experience: productsConfigs.experience,
        tracksYouLike: productsConfigs.tracksYouLike,
        stickerColor: productsConfigs.stickerColor,
      };
      const check = Object.entries(newProductConfigs).some(entry => !entry[1]);
      //console.log(check);
      setButtonEnabled(!check);
    }, 500)



  }, [productsConfigs]);

  const onInputChange = (e) => {
    const { name, value } = e.target;
    setProductsConfigs({ ...productsConfigs, [name]: value });
    
  }

  const saveProductConfigs = (e) => {
    setProductsConfigsCallback({
      ...productsConfigs,
      bikeWeight: bikeWeight.current.value,
      length: length.current.value,
    });
    setProductsConfigs(
      {
        ...productsConfigs,
        bikeWeight: bikeWeight.current.value,
        length: length.current.value,
      }
    )
    setProductId(product.id);
    // setProductsConfigs({
    //   yourWeight: null,
    //   model: null,
    //   length: null,
    //   frontAndBack: null,
    //   diameter: null,
    //   experience: null,
    //   tracksYouLike: null,
    //   stickerColor: null,
    // })
    handleClose();
  }

  let productTags = product.theTags || [];
  console.log(productTags);
  delete productTags[160];
  delete productTags[161];
  let productTagsValues = Object.values(productTags);
  console.log(productTagsValues);
  let tagString = productTagsValues.toString();
  console.log(tagString);


  return (
    <Dialog
      className="dialog-box options-config"
      classes={{ paper: "dialog-box"}}
      BackdropProps={{ style: { backgroundColor: "rgba(255, 255, 0, 1)", opacity: 0.69 } }}
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}>
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>Für dich individuell angepasst</DialogTitle>
      <DialogContent>
        
        <Grid container direction="column" alignItems="center" justifyContent="flex-start">
          <Grid item style={{ padding: 10, width: 'calc(100%)' }}>
            <TextField
              className={classes.root}
              name="yourWeight"
              defaultValue={productsConfigs.yourWeight}
              onChange={onInputChange}
              id="yourWeight"
              label="Körpergewicht in Kg"
              placeholder=""
              helperText="Ohne Ausrüstung"
              fullWidth
              type="number"
              margin="normal"
              InputProps={{
                  disableUnderline: true,
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item style={{ padding: 10, width: 'calc(100%)' }}>
            <TextField
              className={classes.root}
              name="model"
              onChange={onInputChange}
              id="model"
              label="Bike-modell"
              placeholder=""
              helperText=" "
              fullWidth
              defaultValue={productsConfigs.model}
              margin="normal"
              InputProps={{
                  disableUnderline: true,
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
         
        </Grid>

        <Grid container direction="row" alignItems="center" justifyContent="flex-start">

          <Grid item style={{ padding: 10, width: 'calc(50%)' }}>
            <TextField
              inputRef={bikeWeight}
              name="bikeWeight"
              defaultValue={productsConfigs.bikeWeight}
              type="number"
              className={`${classes.root}`}
              id="bikeWeight"
              label="Bike-Gewicht in KG"
              placeholder=""
              helperText="optional"
              fullWidth
              margin="normal"
              InputLabelProps={{
                classes: { root: 'multiply' },
                className: 'test',
              }}
              InputProps={{
                  disableUnderline: true,
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
       
          <Grid item style={{ padding: 10, width: 'calc(50%)' }}>
            <TextField
              className={`${classes.root} ${classes.select}`}
              name="length"
              inputRef={length}
              defaultValue={productsConfigs.length}
              margin="normal"
              id="length"
              label="Dämpfereinbau-länge x Hub"
              placeholder=""
              helperText="Optional"
              fullWidth
              InputProps={{
                  disableUnderline: true,
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          
          <Grid item style={{ padding: 10, width: 'calc(50%)' }}>
            <TextField
              className={classes.root}
              name="frontAndBack"
              defaultValue={productsConfigs.frontAndBack}
              onChange={onInputChange}
              id="frontAndBack"
              label="Federweg vorne und hinten"
              placeholder=""
              helperText=""
              fullWidth
              margin="normal"
              InputProps={{
                  disableUnderline: true,
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          
          <Grid item style={{ padding: 10, width: 'calc(50%)' }}>
            <TextField
              className={classes.root}
              name="diameter"
              defaultValue={productsConfigs.diameter}
              onChange={onInputChange}
              id="diameter"
              label="Laufradgröße vorne und hinten"
              placeholder=""
              helperText=""
              fullWidth
              margin="normal"
              InputProps={{
                  disableUnderline: true,
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          

          <Grid item style={{ padding: 10, width: 'calc(100%)' }}>
            <TextField
              className={classes.root}
              name="tracksYouLike"
              defaultValue={productsConfigs.tracksYouLike}
              onChange={onInputChange}
              margin="normal"
              id="tracksYouLike"
              label="Strecken / Vorlieben"
              placeholder=""
              helperText=""
              fullWidth
              InputProps={{
                  disableUnderline: true,
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          
          
        </Grid>

        
        <Grid container direction="row" alignItems="center" justifyContent="flex-start">
          
          <Grid item style={{ padding: 10, width: 'calc(50%)' }}>
            <TextField
              className={`${classes.root}`}
              name="experience"
              onChange={onInputChange}
              id="experience"
              select
              defaultValue={productsConfigs.experience}
              label="Fahrstil"
              placeholder=""
              helperText=""
              fullWidth
              margin="normal"
              InputProps={{
                  disableUnderline: true,
              }}
              InputLabelProps={{
                shrink: true,
              }}
            >
              <MenuItem key={"Anfänger"} data-index={"Anfänger"} value={"Anfänger"}>Anfänger</MenuItem>
              <MenuItem key={"Fortgeschritten"} data-index={"Fortgeschritten"} value={"Fortgeschritten"}>Fortgeschritten</MenuItem>
              <MenuItem key={"Sport"}data-index={"Sport"} value={"Sport"}>Sport</MenuItem>
              <MenuItem key="Race" data-index={"Race"} value={"Race"}>Race</MenuItem>
              
          </TextField>
          </Grid>
        


          <Grid item style={{ padding: 10, width: 'calc(50%)' }}>
            <TextField
              className={classes.root}
              name="stickerColor"
              defaultValue={productsConfigs.stickerColor}
              onChange={onInputChange}
              id="stickerColor"
              select
              label="Decals-Farbe"
              placeholder=""
              helperText=""
              fullWidth
              margin="normal"
              InputProps={{
                  disableUnderline: true,
              }}
              InputLabelProps={{
                shrink: true,
              }}
            >

              {tagString === 'daempfer,trailhunter' &&
              <MenuItem data-index={"neon-gelb"} value={"neon-gelb"}>neon - gelb</MenuItem>
              }
              {tagString === 'federgabel,trailhunter' &&
              <MenuItem data-index={"neon-gelb"} value={"neon-gelb"}>neon - gelb</MenuItem>
              }
              {tagString === 'federgabel,golden-ride' &&
              <MenuItem data-index={"neon-gelb"} value={"neon-gelb"}>neon - gelb</MenuItem>
              }

              {tagString === 'daempfer,golden-ride' &&
              <MenuItem data-index={"gold"} value={"gold"}>gold</MenuItem>
              }
              {tagString === 'federgabel,trailhunter' &&
              <MenuItem data-index={"gold"} value={"gold"}>gold</MenuItem>
              }
              {tagString === 'federgabel,golden-ride' &&
              <MenuItem data-index={"gold"} value={"gold"}>gold</MenuItem>
              }
              {tagString === 'federgabel,trailhunter' &&
              <MenuItem data-index={"rot"} value={"rot"}>rot</MenuItem>
              }
              {tagString === 'federgabel,golden-ride' &&
              <MenuItem data-index={"rot"} value={"rot"}>rot</MenuItem>
              }
              {tagString === 'federgabel,trailhunter' &&
              <MenuItem data-index={"stealth (metallic anthrazit)"} value={"stealth (metallic anthrazit)"}>stealth (metallic anthrazit)</MenuItem>
              }
              {tagString === 'federgabel,golden-ride' &&
              <MenuItem data-index={"stealth (metallic anthrazit)"} value={"stealth (metallic anthrazit)"}>stealth (metallic anthrazit)</MenuItem>
              }
              {tagString === 'daempfer,trailhunter' &&
              <MenuItem data-index={"keine Decals (original Decals belassen)"} value={"keine Decals (original Decals belassen)"}>keine Decals (original Decals belassen)</MenuItem>
              }
              {tagString === 'daempfer,golden-ride' &&
              <MenuItem data-index={"keine Decals (original Decals belassen)"} value={"keine Decals (original Decals belassen)"}>keine Decals (original Decals belassen)</MenuItem>
              }
              {tagString === 'federgabel,trailhunter' &&
              <MenuItem data-index={"keine Decals (original Decals belassen)"} value={"keine Decals (original Decals belassen)"}>keine Decals (original Decals belassen)</MenuItem>
              }
              {tagString === 'federgabel,golden-ride' &&
              <MenuItem data-index={"keine Decals (original Decals belassen)"} value={"keine Decals (original Decals belassen)"}>keine Decals (original Decals belassen)</MenuItem>
              }

              {/*
              <MenuItem key="neon-gelb" data-index={"neon-gelb"} value={"neon-gelb"}>neon - gelb</MenuItem>
              <MenuItem key="gold" data-index={"gold"} value={"gold"}>gold</MenuItem>
              <MenuItem key="rot" data-index={"rot"} value={"rot"}>rot</MenuItem>
              <MenuItem key="stealth" data-index={"stealth (metallic anthrazit)"} value={"stealth (metallic anthrazit)"}>stealth (metallic anthrazit)</MenuItem>
              <MenuItem key="keine" data-index={"keine Decals (original Decals belassen)"} value={"keine Decals (original Decals belassen)"}>keine Decals (original Decals belassen)</MenuItem>
              */}
              
          </TextField>
          </Grid>
        </Grid>

        <Grid container direction="row" alignItems="center" justifyContent="center">
          <Button disabled={!buttonEnabled} className="options-config-button" onClick={saveProductConfigs}>SPEICHERN</Button>
        </Grid>

      </DialogContent>
    </Dialog>
  );
}
